import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7xgwjjb7p6: FaireBrandEntity = {
  token: "b_7xgwjjb7p6",
  type: "brand",
  name: "Everyday Supply Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/8340f21f1d8252f4aa645046123be820a2a874c5ba0db2fb927ce4f8c1ecf540.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/90acf8bc7ef154479c4843006a66af6af68278037ce9815d2652b74f04a5ec89.png",
  logoUrl:
    "https://cdn.faire.com/fastly/8340f21f1d8252f4aa645046123be820a2a874c5ba0db2fb927ce4f8c1ecf540.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/90acf8bc7ef154479c4843006a66af6af68278037ce9815d2652b74f04a5ec89.png",
  location: "Burlington, MA, USA",
  minimumOrderDollars: 50,
  rating: 4.1,
  reviewCount: 108,
  isInsider: true,
  description:
    "Everyday Supply Co provides wholesale essentials, household goods, and pantry staples from brands you know and trust.  ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:53.616Z",
    importedBy: "entity-db-cli",
  },
};
